import React from "react";
import type { PriceTier } from "../types/megapack";
import { CTAButton } from "./CTAButton";
import { E } from "./Emoji";
type PriceCardProps = {
  tier: PriceTier;
};

/** Tarjeta centrada para el cierre de la página */
export function PriceCard({
  tier
}: PriceCardProps) {
  const isPro = tier.id === "pro";
  return <article className={`rounded-2xl border bg-navy p-6 text-center ${isPro ? "border-2 border-bright shadow-[0_0_30px_rgba(77,148,255,0.3)]" : "border-line/50"}`} data-id="element-31" data-mp="28s93nchtof23">
      <span className="text-3xl" data-id="element-32" data-mp="31f3mk4yzr6dg"><E data-id="element-33" data-mp="31fdc5rg4jbim">{tier.emoji}</E></span>
      <h3 className="mt-2 text-xl font-black uppercase text-white" data-id="element-34" data-mp="2miw2r5rhw6yp">
        <E data-id="element-35" data-mp="2mimdjke9y3u2">{tier.title}</E>
      </h3>
      <p className="mt-1 text-sm text-mute" data-id="element-36" data-mp="2rhp7o9spupn9">{tier.subtitle}</p>
      {tier.referencePrice && <p className="mt-4 text-sm text-mute line-through" data-id="element-37" data-mp="1b3p84zxs920j">{tier.referencePrice}</p>}
      <p className={`${tier.referencePrice ? "" : "mt-4"} text-4xl font-black text-sky`} data-id="element-38" data-mp="1b5tnqf51npgn">{tier.price}</p>
      <div className="mt-5" data-id="element-39" data-mp="1g0folodi1zmh">
        <CTAButton href={tier.href} data-id="element-40" data-mp="3klktga8coy7p">{tier.cta}</CTAButton>
      </div>
    </article>;
}